export const loanPurposeListItem = ["Medical Emergency", "Salary Delay", "Personal Emergency", "Education", "Rent / Bills", "Others"];

export const ORDER_ID_LOCAL_STORAGE_KEY =  'orderId';

export const START_FINBOX_FLOW_LOCAL_KEY = "start_finbox_flow";

export const MONTH_12_FLAGS_STATUS = {
  APPROVED: "Approved",
  NOT_ELIGIBLE: "Not Eligible",
  PROCEED_TO_BANK: "Proceed to Bank",
};

export const IS_PERSONAL_LOAN_SELECTED = "is_personal_loan_selected"; // localStorage key to track if personal loan is selected
export const PREVIOUS_ROUTE_LOCAL_STORAGE_KEY = 'previous_route';

export const PAYMENT_RESPONSE_LOCAL_STORAGE_KEY = 'payment_response';

export const PAYMENT_GATEWAY = {
  ROZAR_PAY: 'razorpay',
  PAYU: "payu",
};

export const paymentStatusEnum = {
  SUCCESS: 'success',
  FAILURE: 'failed',
  PENDING: 'pending',
};

export const SELECTED_PAYMENT_GATEWAY = 'selected_payment_gateway';

export const MONTHLY_INCOME_CONSENT_TEXT = <>I confirm that my annual household income is <strong>more than ₹3,00,000,</strong> and the information provided is true and correct.</>;

export const EMI_PLAN_LOCAL_STORAGE_KEY = 'emi_plan';
export const OFFER_TYPE_LOCAL_STORAGE_KEY = 'offer_type';
export const SELECTED_PRADUCT_TYPE_ID_LOCAL_STORAGE_KEY = 'selected_product_type_id';
export const IS_EMI_PRODUCT = 1;

export const LEAD_STATUS = {
  FRESH_LEAD: "Fresh Lead",
  CALLBACK: "Callback",
  INTERESTED: "Interested",
  NOT_INTERESTED: "Not Interested",
  WRONG_NUMBER: "Wrong Number",
  DOCUMENT_RECEIVED: "Document Received",
  APPROVED: "Approved",
  HOLD: "Hold",
  DISBURSAL_SHEET_SEND: "Disbursal Sheet Send",
  DISBURSED: "Disbursed",
  CLOSED: "Closed",
  PART_PAYMENT: "Part Payment",
  SETTLEMENT: "Settlement",
  INCOMPLETE_DOCUMENTS: "Incomplete Documents",
  DNC: "DNC",
  REJECTED: "Rejected",
  NOT_ELIGIBLE: "Not Eligible",
  DUPLICATE: "Duplicate",
  OTHER: "Other",
  NO_ANSWER: "No Answer",
  EMI_PAID: "EMI Paid",
  LESS_SALARY: "Less Salary",
  OUT_OF_RANGE: "Out of Range",
  EMI_PRECLOSE: "EMI PRECLOSE",
  BANK_UPDATE_REJECTED: "Bank Update Rejected",
  APPROVED_PROCESS: "Approved Process",
  REJECTED_PROCESS: "Rejected Process",
  HOLD_PROCESS: "Hold Process",
  NOT_REQUIRED: "Not Required",
  NOT_REQUIRED_PROCESS: "Not Required Process",
  BLACKLISTED: "Blacklisted",
  DISBURSAL_APPROVED: "Disbursal Approved",
  BANK_UPDATE_HOLD: "Bank Update Hold",
  INCOMPLETE_USER: "Incomplete User"
};
